<script lang="ts">
	import { driver_state } from '$lib/features/profile/states/driver_state';
	import { auth_state } from '$lib/features/auth/state/auth_state';
	import { Loc } from '$lib/tools/locale.svelte';
	import Input from '$lib/components/ui/input/input.svelte';
	import { onMount } from 'svelte';

	let sign_in_message = $state('');
	let expand_auth_form = $state(false);
	let auth_call_in_progress = $state(false);
	let phone_number = $state<string>();
	let phone_number_input = $state<HTMLInputElement | null>(null);

	async function sign_in_submit_handler(e: any) {
		e.preventDefault();

		auth_call_in_progress = true;

		const { fn_status } = await auth_state.sign_in(e.target);
		if (fn_status) auth_call_in_progress = true;
		else auth_call_in_progress = false;
	}

	async function sign_out_handler(e: any) {
		e.preventDefault();
		await auth_state.sign_out();
	}

	onMount(() => {
		setTimeout(() => {
			expand_auth_form = true;
		}, 500);
	});
</script>

<div class="mx-4 m-auto flex flex-col items-center justify-center">
	<div
		class="flex w-full max-w-sm flex-col justify-center rounded-2xl border border-border bg-card px-6 py-16 shadow-sm"
	>
		<img class="mx-auto w-1/2 basis-1/3" src="/logos/shaggaga-full.png" alt={Loc('app_brand')} />

		<div class="my-2 h-px w-full bg-border outline-0"></div>
		<div class="flex basis-2/3 flex-col justify-center">
			{#if !expand_auth_form || auth_call_in_progress}
				<div class="progress mx-auto my-3"></div>
			{:else if auth_state.value}
				<!-- Sign out -->
				<div>
					<div class="text-center text-xl font-semibold text-foreground">
						{Loc('welcome')}
						{driver_state.value?.name}
					</div>
					<form class="my-auto mt-4" onsubmit={sign_out_handler} id="login_form">
						<button
							name="sign_in"
							type="submit"
							class="w-full rounded-lg bg-primary px-4 py-2 text-primary-foreground transition-colors duration-300 hover:bg-primary/90 focus:bg-primary/90 focus:outline-none"
						>
							{Loc('logout')}
						</button>
					</form>
				</div>
			{:else}
				<form class="my-auto mt-2" onsubmit={sign_in_submit_handler} id="login_form">
					<div>
						<label for="email" class="block text-sm text-muted-foreground">{Loc('phone_number')}</label>
						<Input
							type="tel"
							inputmode="numeric"
							name="email"
							bind:value={phone_number}
							bind:ref={phone_number_input}
							autocomplete="username"
							required
							dir="ltr"
							placeholder={Loc('phone_number')}
							class="mt-2 h-11"
							onkeypress={(e) => {
								const input_value = e.key;
								if (!input_value) return;

								const valid_phone_number_char = /^[0-9]$/;
								const selected_text_length =
									(phone_number_input!.selectionEnd ?? 0) - (phone_number_input!.selectionStart ?? 0);
								const newInputLength = phone_number_input!.value?.length - selected_text_length + 1;

								if (!valid_phone_number_char.test(input_value) || newInputLength > 10) {
									e.preventDefault();
								}
							}}
							onpaste={(e) => {
								const pasted_text = e.clipboardData?.getData('text');
								const pasted_length = pasted_text?.length;
								if (!pasted_length) return;
								const selected_text_length =
									(phone_number_input!.selectionEnd ?? 0) - (phone_number_input!.selectionStart ?? 0);
								if (pasted_length + (phone_number_input!.value?.length ?? 0) - selected_text_length > 10) {
									e.preventDefault();
								}
							}}
						/>
					</div>

					<div class="mt-4">
						<label for="password" class="block text-sm text-muted-foreground">{Loc('password')}</label>

						<Input
							type="password"
							name="password"
							required
							autocomplete="current-password"
							dir="ltr"
							placeholder={Loc('password')}
							class="mt-2 h-11"
						/>
					</div>
					<p class="mx-auto text-center text-destructive">{sign_in_message}</p>

					<div class="mt-6">
						<button
							type="submit"
							class="w-full rounded-lg bg-primary px-4 py-2 text-primary-foreground transition-colors duration-300 hover:bg-primary/90 focus:bg-primary/90 focus:outline-none"
						>
							{Loc('login')}
						</button>
					</div>
				</form>
			{/if}
		</div>
	</div>
</div>

<style>
	.progress {
		width: 120px;
		height: 22px;
		border-radius: 20px;
		color: var(--primary);
		border: 2px solid;
		position: relative;
	}
	.progress::before {
		content: '';
		position: absolute;
		margin: 2px;
		inset: 0 100% 0 0;
		border-radius: inherit;
		background: currentColor;
		animation: p6 2s infinite;
	}
	@keyframes p6 {
		100% {
			inset: 0;
		}
	}
</style>
